export default {
  validar: state => state.validar
};
